// @ts-nocheck
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Component, FormEvent, PropsWithChildren, ReactNode } from 'react';
import Content from './login.content';
import {
  getContent,
  buildErrorMsgFromForm,
  testPassword,
  PWReqsMessage,
  isNativeAppBrowser,
  sendNativeEvent,
} from '../../utils';
import { Button } from '../../_shared/button';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Logo from '../../_shared/logo';
import { Alert, Checkbox, message } from 'antd';
import styles from '../authentication.styles';
import SharedStyles from '../../_shared/styles';
import { AppState } from '../../app.state';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { decryptString } from '../../utils';
import moment from 'moment';
import { Emails } from '../../_shared/lib/emails';
import { sendEmail } from '../../_shared/services/email.service';
import { getUser } from '../../_shared/services/manage-users.service';
import { get, noop } from 'lodash';
import { WithForm } from '../../_shared/form';
import { WithAppConfig } from '../../_shared/hooks/useAppConfig';
import { LoginLogo } from './loginlogo';
import { getUrl } from '../../config';

interface IProps extends RouteComponentProps, PropsWithChildren {
  signUp: (un: string, pw: string) => Promise<boolean>;
  signIn: (
    un: string,
    pw: string,
    checkRole?: boolean,
    setToActive?: boolean
  ) => Promise<boolean | { pin: string; method: string }>;
  appState: AppState;
  destination?: string;
  inputContainer?: () => ReactNode;
  form?: any;
  app?: any;
}

class LoginComponent extends Component<IProps> {
  state = {
    loading: false,
    isSignUp: false,
    checked: false,
    email: '',
    estring: '',
    isExpiredLink: false,
    toDisplay: (p: any) => [
      {
        title: 'Email',
        var: 'email',
        validateTrigger: 'onBlur',
        props: {
          disabled: p.isSignUp,
        },
        rules: [
          {
            type: 'email',
            message: 'The input is not a valid E-mail. ',
            transform: (v: string) => v.trim(),
          },
          {
            required: true,
            message: 'The input is not a valid E-mail. ',
          },
          {
            max: 60,
            message: 'Email is limited to 60 characters. ',
          },
        ],
      },
      {
        title: 'Password',
        var: 'password',
        validateTrigger: 'onBlur',
        type: 'password',
        rules: [
          {
            required: true,
            message: 'Please input your password!',
          },
        ],
        subtext: () =>
          !p.isSignUp && (
            <div onClick={this.goToForgotPassword} css={css(styles.fgPassword)}>
              {Content().forgotPasswordBtn}
            </div>
          ),
      },
    ],
  };
  componentDidMount = async () => {
    const { state } = this.props.history.location;
    const { setFieldsValue } = this.props.form;

    if (state && state.signUp) {
      this.setState({ loading: true });
      let email = state.signUp;
      try {
        const vals = JSON.parse(decryptString(state.signUp));
        email = vals.email;
        const diff = moment().diff(moment(vals.date), 'hours');
        const user = await getUser(email);

        const isActive = get(user, 'isActive');
        if (isActive) {
          message.error('This Sign Up Link has already been used. Please login.');
          return this.setState({
            loading: false,
          });
        }

        if (diff > 24) {
          this.setState({
            isExpiredLink: true,
            email,
            loading: false,
          });
        }
      } catch (err) {
        console.error('An unknown error occurred. Please try again.');
      }

      setFieldsValue({ email });

      this.setState({ isSignUp: true, estring: state.signUp, loading: false });
    }
  };
  checkIfEmailAlreadyUsed = async () => {};
  goToForgotPassword = () => {
    this.props.history.push('/forgotPassword', { destination: this.props.destination });
  };
  signInSubmit = async (e?: FormEvent) => {
    e && e.preventDefault && e.preventDefault();
    if (this.state.loading) {
      return;
    }

    this.setState({ loading: true });

    this.props.form.validateFieldsAndScroll(async (err: any, values: any) => {
      if (err) {
        const error = buildErrorMsgFromForm(err);
        message.error(this.getErrorText(error));
        return this.setState({ loading: false });
      }
      const { email, password } = values;

      const _email = email.toLowerCase().trim();

      const doTheSignin = async (checkRole = true, setToActive = false) => {
        try {
          const req = await this.props.signIn(
            _email,
            password,
            checkRole,
            setToActive
          );
          if (!req) {
            message.error('That username and password combination is not valid.');
            return this.setState({
              loading: false,
            });
          } else if (get(req, 'pin')) {
            this.props.history.push('/verify', {
              destination: this.props.destination,
              email: _email,
              password,
              is2fa: get(req, 'pin'),
              method: get(req, 'method'),
            });
          } else {
            this.props.history.push(this.props.destination || '/dashboard');
          }
        } catch (err) {
          if (err && err.code === 'UserNotConfirmedException') {
            this.props.history.push('/verify', {
              destination: this.props.destination,
              email: _email,
              password,
            });
          } else {
            message.error(
              this.getErrorText(
                get(
                  err,
                  'message',
                  'That username and password combination is not valid.'
                )
              )
            );
            this.setState({
              loading: false,
            });
          }
        }
      };

      if (this.state.isSignUp) {
        try {
          const test = testPassword(password);
          if (!test) {
            message.error(PWReqsMessage);
            return this.setState({
              loading: false,
            });
          }
          await this.props.signUp(this.state.estring, password);
          doTheSignin(true, true);
        } catch (err) {
          if (err.message.indexOf('Email address already exists') > -1) {
            this.setState(
              {
                isSignUp: false,
                loading: false,
              },
              () => this.signInSubmit()
            );
          } else {
            message.error(this.getErrorText(err.message));
            this.setState({
              loading: false,
            });
          }
        }
      } else {
        doTheSignin();
      }
    });
  };

  onChange = (e: CheckboxChangeEvent) => {
    this.setState({ checked: e.target.checked });
  };

  resendCode = async () => {
    try {
      const { email } = this.state;
      const {
        form: { setFieldsValue },
      } = this.props;
      const Email = Emails.invite({ ToAddresses: [email] });

      await sendEmail(Email);
      this.setState({
        email: undefined,
        isExpiredLink: false,
        estring: '',
        isSignUp: false,
      });
      setFieldsValue({ email: '' });
      message.success('New Sign Up Link sent to email');
    } catch (err) {
      message.error(
        `There was a problem sending a Sign Up link to that email. Please try again.`
      );
    }
  };

  renderExpired = () => {
    return (
      <div className="Login" css={css(styles.container)}>
        <div css={css(SharedStyles.logoWrap)}>
          <Logo />
        </div>

        <Alert message="This Sign Up link has expired." type="error" />

        <div css={css(styles.buttonContainer, `margin-top: 20px;`)}>
          <Button
            css={css('margin-bottom: 10px;')}
            onClick={this.resendCode}
            title="Resend Sign Up Link"
          />
        </div>
      </div>
    );
  };

  getErrorText = (error: string | null) => {
    if (error && error.toLowerCase().includes('network error')) {
      return `${error}. Please make sure that the domains https://aeras.dentalez.com and ${getUrl().replace('/api', '')} are allowed under your organization’s IT policies`;
    }
    return error;
  }

  render() {
    const { Form } = this.props.form;
    const { error, loading, isSignUp, isExpiredLink, toDisplay } = this.state;
    // AER-1667 (R1): Submit is no longer gated by empty email/password — required
    // fields now validate on blur and on submit (validateFieldsAndScroll focuses
    // the first error). It stays disabled only while signing in (loading) and, for
    // the sign-up variant, until the user consents to the Terms/Privacy checkbox
    // (a legal gate, not field validation).
    const btnDisabled = loading || (isSignUp && !this.state.checked);
    const content = getContent(Content);

    const onSubmit = btnDisabled ? noop : this.signInSubmit;

    return isExpiredLink ? (
      this.renderExpired()
    ) : (
      <div className="Login" css={css(styles.container)}>
        <div css={css(SharedStyles.logoWrap)}>
          <LoginLogo />
        </div>

        <div css={css(styles.inputContainer)}>
          {/* AER-1755: full-bleed slot at the top of the login card. The
              Equipment Registration flow passes the purple equipment header bar
              (serial number + model of the scanned unit) in here. The prop had
              been declared but stopped being rendered, which is why the bar
              only reappeared later, on Organization Details. It renders nothing
              when the prop is absent, so the plain /login screen is unchanged. */}
          {this.props.inputContainer && this.props.inputContainer()}
          <p
            css={css(
              styles.title,
              `color: ${get(this, 'props.app.style.colors.primary')}`
            )}
          >
            {isSignUp ? content.signUp : content.signIn}
          </p>

          {isSignUp && (
            <div>
              <p css={css(styles.passwordPrompt)}>{content.passwordPrompt}</p>
            </div>
          )}

          {!!error && (
            <Alert
              message={error}
              type={'error'}
              closable
              onClose={() => this.setState({ error: null })}
            />
          )}

          <Form
            items={toDisplay(this.state)}
            onSubmit={onSubmit}
            forceUpdate={this}
          >
            {isSignUp && (
              <div>
                <Checkbox checked={this.state.checked} onChange={this.onChange}>
                  By checking this box, you consent to and agree to our{' '}
                  <a
                    href={'https://www.aerasintel.com/privacy-policy'}
                    target="_blank"
                  >
                    Privacy Policy
                  </a>{' '}
                  and our{' '}
                  <a href={'https://www.aerasintel.com/terms-of-use'} target="_blank">
                    Terms of Use
                  </a>
                  .
                </Checkbox>
              </div>
            )}

            <div css={css(styles.buttonContainer)}>
              <Button
                loading={loading}
                title={isSignUp ? content.buttonSignUp : content.button}
                onClick={this.signInSubmit}
                disabled={btnDisabled}
              />
            </div>
          </Form>

          {this.props.children}
        </div>

        {isNativeAppBrowser() && <Button style={{ marginTop: 10 }} onClick={() => sendNativeEvent({ action: 'router', data: '/setupwifi' })} title={'Register Equipment'} />}
      </div>
    );
  }
}

export const Login = WithAppConfig(WithForm(withRouter(LoginComponent)));
